export { default as DiscountSection } from './DiscountSection';